'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = require('../../utils');

var _nitroRipple = require('../nitro-ripple');

var _nitroRipple2 = _interopRequireDefault(_nitroRipple);

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NitroRadio = function (_Component) {
  _inherits(NitroRadio, _Component);

  function NitroRadio() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NitroRadio);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NitroRadio.__proto__ || Object.getPrototypeOf(NitroRadio)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
      if (_this.ripple) {
        _this.ripple.trigger();
      }
    }, _this.handleChange = function (event) {
      if (typeof _this.props.action === 'function') {
        _this.props.action(event, _this.props.value);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NitroRadio, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          checkboxPosition = _props.checkboxPosition,
          checked = _props.checked,
          className = _props.className,
          disabled = _props.disabled,
          disableRipple = _props.disableRipple,
          fullWidth = _props.fullWidth,
          label = _props.label,
          labelPosition = _props.labelPosition,
          labelVariant = _props.labelVariant,
          maxWidth = _props.maxWidth,
          name = _props.name,
          rippleScaleInitial = _props.rippleScaleInitial,
          rippleScaleFinal = _props.rippleScaleFinal,
          size = _props.size,
          value = _props.value,
          variant = _props.variant,
          wrapText = _props.wrapText;


      var labelElement = _react2.default.createElement(
        _styles.RadioLabel,
        {
          variant: variant,
          wrapText: wrapText,
          labelVariant: labelVariant,
          disabled: disabled
        },
        label
      );

      return _react2.default.createElement(
        _styles.RadioWrapper,
        {
          className: className,
          disabled: disabled,
          maxWidth: maxWidth
        },
        _react2.default.createElement(
          _styles.RadioLabelWrapper,
          {
            fullWidth: fullWidth,
            disabled: disabled
          },
          labelPosition === 'left' && labelElement,
          _react2.default.createElement(_styles.RadioInput, {
            disabled: disabled,
            onClick: this.handleClick,
            onChange: this.handleChange,
            type: 'radio',
            innerRef: function innerRef(c) {
              _this2.input = c;
            },
            name: name,
            value: value || label,
            checked: checked
          }),
          _react2.default.createElement(
            _styles.RadioBox,
            {
              checkboxPosition: checkboxPosition,
              disabled: disabled,
              labelPosition: labelPosition,
              size: size,
              variant: variant
            },
            !disableRipple && _react2.default.createElement(_nitroRipple2.default, {
              scaleInitial: rippleScaleInitial,
              scaleFinal: rippleScaleFinal,
              ref: function ref(c) {
                _this2.ripple = c;
              },
              variant: variant
            })
          ),
          labelPosition === 'right' && labelElement
        ),
        disabled && _react2.default.createElement(_utils.DisableCover, null)
      );
    }
  }]);

  return NitroRadio;
}(_react.Component);

NitroRadio.propTypes = {
  action: _propTypes2.default.func,
  checkboxPosition: _propTypes2.default.oneOf(['top', 'center', 'bottom']),
  checked: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  disableRipple: _propTypes2.default.bool,
  fullWidth: _propTypes2.default.bool,
  label: _propTypes2.default.string,
  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
  labelVariant: _propTypes2.default.string,
  maxWidth: _propTypes2.default.string,
  name: _propTypes2.default.string,
  rippleScaleInitial: _propTypes2.default.number,
  rippleScaleFinal: _propTypes2.default.number,
  size: _propTypes2.default.number,
  value: _propTypes2.default.string,
  variant: _propTypes2.default.string,
  wrapText: _propTypes2.default.bool
};

NitroRadio.defaultProps = {
  checkboxPosition: 'center',
  labelPosition: 'right',
  maxWidth: '250px',
  rippleScaleInitial: 1,
  rippleScaleFinal: 2.5,
  size: 24,
  variant: 'secondary'
};

exports.default = NitroRadio;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-radio/NitroRadio.js
// module id = 3029
// module chunks = 4